import React from 'react';
import { useGame } from '@/app/providers/GameContextProvider';
import { GameMode } from '@/lib/types/common/GameMode';
import { CoopRole } from '@/lib/types/common/Player';
import { motion } from 'framer-motion';
import { useTranslation } from '@/hooks/useTranslation';

const CoopRoleIndicator = () => {
    const { gameState, room } = useGame();
    const { t } = useTranslation();

    // Only show in Coop mode
    if (gameState?.gameMode !== GameMode.COOP) return null;

    const currentPlayer = gameState?.players?.get(room?.sessionId || "");
    const coopRole = currentPlayer?.coopRole as CoopRole;

    if (!coopRole || coopRole === CoopRole.NONE) return null;

    const isPhotosphereRole = coopRole === CoopRole.PHOTOSPHERE;

    return (
        <motion.div
            initial={{ opacity: 0, y: -20, x: '-50%' }}
            animate={{ opacity: 1, y: 0, x: '-50%' }}
            className="absolute top-20 left-1/2 z-50 pointer-events-none select-none"
        >
            <div className={`text-xl text-shadow-border shadow-amber-800 text-yellow-200 backdrop-blur-sm`}>
                {isPhotosphereRole
                    ? t('play.coop.photosphereRoleInfo')
                    : t('play.coop.mapRoleInfo')}
            </div>
        </motion.div>
    );
};

export default CoopRoleIndicator;
